// Modules
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Styles
import styles from './SuccessDisplay.module.scss';

// Components
import CustomHR from './CustomHR';

const SuccessDisplay = (props) => {
  const {
    children,
    heading = 'Success',
    subHeading,
    useHeading = true,
    useHR = true,
    customStylesModuleReference: custStyles,
  } = props;

  return (
    <section className={`${styles.container} ${custStyles?.container ?? ''}`}>
      <header className={`${styles.header} ${custStyles?.header ?? ''}`}>
        <span className={`${styles.icon} ${custStyles?.icon ?? ''}`}>
          <FontAwesomeIcon icon={'check-circle'} />
        </span>
        {/*
          This component will almost always have a heading, but the subheading is used
          less frequently
          So, hiding the heading must be explicit (because we have a default value)
          And because there is no default value for the subheading we show it whenever a
          value is passed in
        */}
        {useHeading && <h3 className={custStyles?.heading ?? ''}>{heading}</h3>}
        {subHeading && (
          <h4 className={custStyles?.subheading ?? ''}>{subHeading}</h4>
        )}
      </header>

      {useHR && <CustomHR />}

      {children}
    </section>
  );
};

export default SuccessDisplay;
